import React from "react";

type NavLinkProps = {
  label: string;
  active?: boolean;
};

export function NavLink({ label, active = false }: NavLinkProps) {
  return (
    <button
      className={`text-xs font-medium ${
        active ? "text-slate-900" : "text-slate-500 hover:text-slate-800"
      }`}
    >
      {label}
    </button>
  );
}
